import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import AstroImage from '@/components/ui/custom/AstroImage';
import Skeleton from '@/components/ui/custom/Skeleton';
import { ClassNameComponent } from '@/utils/ClassNameComponent';

export type Props = {
  src?: string;
  to?: string;
  onClick?: () => void;
  alternativeSrc?: string;
  className?: ClassNameComponent;
};

export default function CoursePathCardImage(props: Props) {
  const {
    to = '',
    src,
    alternativeSrc = '/images/course-default-image.png',
    className,
    onClick,
  } = props;
  const imageSrc = src || alternativeSrc;

  return (
    <ConditionalWrapper condition={!!to} wrapper={<Link to={to} />}>
      <figure className={twMerge('relative min-h-full', className?.figure)}>
        <AstroImage
          onClick={onClick}
          data-testid="courseCardImage"
          src={imageSrc}
          className={twMerge(
            'rounded-md min-h-full aspect-video object-cover',
            className?.img,
          )}
          alt="course-banner"
          alternativesrc={alternativeSrc}
          validation={{
            renderLoading: () => (
              <Skeleton className="rounded-md w-full h-[12.181rem] bg-primary-content" />
            ),
          }}
        />
      </figure>
    </ConditionalWrapper>
  );
}
